import { setMeta } from '@/router/middleware'
import routerView from '@/views/account/routerView'


const AccountLogOut = () => import ('@/views/account/LogOut')
const AccountEdit   = () => import ('@/views/account/Edit')


export default {
    path: 'account',
    redirect: 'account/edit',
    component: routerView,
    children: [
        {
            path: 'edit',
            name: 'account.edit',
            component: AccountEdit,
            meta: {
                middleware: [setMeta],
                labelTrans: 'edit_account',
            }
        },
        {
            path: 'logout',
            name: 'logout',
            component: AccountLogOut,
            meta: {
                middleware: [setMeta],
                labelTrans: 'logout',
            }
        },
    ]
}